import { Skeleton } from '@parrot-software/design-system';

/**
 * Skeleton placeholder for the Receipt step while admin info and brands load.
 * Mirrors the visual structure of the form to prevent layout shift.
 */
export const ReceiptStepSkeleton = () => (
  <>
    {/* Section 1: Commercial info */}
    <div className="flex flex-col gap-4">
      <Skeleton className="h-6 w-48 bg-muted" />
      <div className="grid grid-cols-3 gap-4">
        <div className="flex flex-col gap-1">
          <Skeleton className="h-5 w-32 bg-muted" />
          <Skeleton className="h-9 w-full rounded-md bg-muted" />
        </div>
      </div>
    </div>

    {/* Section 2: Fiscal info */}
    <div className="flex flex-col gap-4">
      <Skeleton className="h-6 w-40 bg-muted" />
      <div className="grid grid-cols-3 gap-4">
        <div className="flex flex-col gap-1">
          <Skeleton className="h-5 w-24 bg-muted" />
          <Skeleton className="h-9 w-full rounded-md bg-muted" />
        </div>
        <div className="flex flex-col gap-1">
          <Skeleton className="h-5 w-16 bg-muted" />
          <Skeleton className="h-9 w-full rounded-md bg-muted" />
        </div>
        <div className="col-span-3 flex flex-col gap-1">
          <Skeleton className="h-5 w-28 bg-muted" />
          <Skeleton className="h-9 w-full rounded-md bg-muted" />
        </div>
      </div>
    </div>

    {/* Section 3: Brand fiscal choices */}
    <div className="flex flex-col gap-6">
      <Skeleton className="h-6 w-72 bg-muted" />
      <div className="flex gap-4">
        <Skeleton className="h-6 w-[100px] shrink-0 bg-muted" />
        <Skeleton className="h-24 flex-1 rounded-xl bg-muted" />
        <Skeleton className="h-24 flex-1 rounded-xl bg-muted" />
      </div>
    </div>
  </>
);
